import $ from "jquery";
import 'slick-carousel'


$('.slider-stable').slick({
  arrows: false,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: true,
  speed: 800,
  easing: 'ease',
  initialSlide: 2,
  swipe: false,
  waitForAnimate: false,
  centerMode: false,
  responsive: [{
    breakpoint: 1025,
    settings: {
      slidesToShow: 1,
      arrows: false,
      slidesToScroll: 1,
      dots: true
    }
  }]
});
